module.exports = __webpack_public_path__ + "8a1c4f3f35af83959efb83a30aa92526.pdf";